__turbopack_context__.v({
  "sidebar": "Bn81jG_sidebar",
  "sidebarLeft": "Bn81jG_sidebarLeft",
  "sidebarRight": "Bn81jG_sidebarRight",
});
